import React from 'react';
import { FiSmartphone, FiBarChart2, FiVideo, FiShield, FiMail, FiDownload } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-green-600 text-white py-20">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-4">
            Welcome to Mandi Live
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-green-100">
            Your complete farming solution in one place
          </p>
          <button className="bg-white text-green-600 px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition duration-300 flex items-center mx-auto gap-2">
            <FiDownload className="w-5 h-5" />
            Download APK
          </button>
        </div>
      </section>

      {/* Key Features Section */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">
            Key Features
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Easy to Use */}
            <div className="text-center p-6 bg-white rounded-lg shadow-sm">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <FiSmartphone className="w-8 h-8 text-blue-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Easy to Use</h3>
              <p className="text-gray-600 text-sm">
                Intuitive interface designed specifically for farmers of all tech levels.
              </p>
            </div>

            {/* Real-time Analytics */}
            <div className="text-center p-6 bg-white rounded-lg shadow-sm">
              <div className="w-16 h-16 bg-green-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <FiBarChart2 className="w-8 h-8 text-green-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Real-time Analytics</h3>
              <p className="text-gray-600 text-sm">
                Track your Crops Price with real-time data and insights.
              </p>
            </div>

            {/* Video Updates */}
            <div className="text-center p-6 bg-white rounded-lg shadow-sm">
              <div className="w-16 h-16 bg-purple-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <FiVideo className="w-8 h-8 text-purple-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Video Updates</h3>
              <p className="text-gray-600 text-sm">
                Real Time Video Updates of Mandi Bhav.
              </p>
            </div>

            {/* Secure & Private */}
            <div className="text-center p-6 bg-white rounded-lg shadow-sm">
              <div className="w-16 h-16 bg-orange-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <FiShield className="w-8 h-8 text-orange-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Secure & Private</h3>
              <p className="text-gray-600 text-sm">
                Your data is protected with enterprise-grade security measures.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Support Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">
            Support
          </h2>
          
          <div className="max-w-2xl mx-auto">
            {/* Need Help */}
            <div className="mb-12 text-center">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Need Help?</h3>
              <p className="text-gray-600 mb-4">
                Our support team is here to help you with any questions or issues you might have.
              </p>
              <a 
                href="mailto:support@farmersapp.com" 
                className="text-green-600 hover:text-green-700 flex items-center justify-center gap-2"
              >
                <FiMail className="w-5 h-5" />
                support@farmersapp.com
              </a>
            </div>

            {/* Download App */}
            <div className="text-center">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Download Our App</h3>
              <p className="text-gray-600 mb-6">
                Get the latest version of our app for the best experience.
              </p>
              <button className="bg-green-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-700 transition duration-300 flex items-center mx-auto gap-2">
                <FiDownload className="w-5 h-5" />
                Download APK Now
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            {/* Brand Section */}
            <div className="text-center md:text-left">
              <h3 className="text-xl font-bold text-white mb-4">Mandi Live</h3>
              <p className="text-gray-300 text-sm leading-relaxed">
                Your complete farming solution providing real-time mandi prices, weather updates, and agricultural insights.
              </p>
            </div>

            {/* Quick Links */}
            <div className="text-center">
              <h4 className="text-lg font-semibold text-white mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li>
                  <a href="#features" className="text-gray-300 hover:text-white transition duration-200 text-sm">
                    Features
                  </a>
                </li>
                <li>
                  <a href="#support" className="text-gray-300 hover:text-white transition duration-200 text-sm">
                    Support
                  </a>
                </li>
                <li>
                  <a href="mailto:support@mandilive.in" className="text-gray-300 hover:text-white transition duration-200 text-sm">
                    Contact Us
                  </a>
                </li>
              </ul>
            </div>

            {/* Legal Links */}
            <div className="text-center md:text-right">
              <h4 className="text-lg font-semibold text-white mb-4">Legal</h4>
              <ul className="space-y-2">
                <li>
                  <Link 
                    to="/privacy-policy" 
                    className="text-gray-300 hover:text-white transition duration-200 text-sm"
                  >
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <a href="#terms" className="text-gray-300 hover:text-white transition duration-200 text-sm">
                    Terms of Service
                  </a>
                </li>
                <li>
                  <a href="#disclaimer" className="text-gray-300 hover:text-white transition duration-200 text-sm">
                    Disclaimer
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-gray-700 pt-6">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-gray-300 text-sm mb-4 md:mb-0">
                © {new Date().getFullYear()} Mandi Live. All rights reserved.
              </p>
              <div className="flex items-center space-x-4">
                <span className="text-gray-300 text-sm">Available at:</span>
                <span className="text-green-400 text-sm font-medium">mandilive.in</span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
